module.exports = __webpack_public_path__ + "static/media/promo.51017dbf.png";